import React, { useState } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

const menuItems = [
  { name: 'About Us', to: '/about' },
  {
    name: 'Automotive',
    to: '/automotive',
    dropdown: [
      { name: 'Skin & Eye Care Film', to: '/skin-eye-care' },
      { name: 'Nano Ceramic Film', to: '/nano-ceramic' },
      { name: 'Platinum Signature', to: '/platinum-signature' },
      { name: 'Reflective Film', to: '/reflective-film' },
      { name: 'Windshield Protection', to: '/windshield-protection' },
      { name: 'Pre-Cut Films', to: '/pre-cut-films' }
    ]
  },
  {
    name: 'Architectural',
    to: '/architectural',
    dropdown: [
      { name: 'Dyed Reflective Film', to: '/dyed-reflective' },
      { name: '2-Ply Reflective Film', to: '/2-ply-reflective' },
      { name: '3-Ply Reflective Film', to: '/3-ply-reflective' },
      { name: 'Signature Sputtering', to: '/signature-sputtering' },
      { name: 'Safety & Security Film', to: '/safety-security-films' },
      { name: 'Decorative Film', to: '/decorative-films' }
    ]
  }
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdownToggle = (menuName) => {
    setActiveDropdown(activeDropdown === menuName ? null : menuName);
  };

  return (
    <>
      <div className="header__top-bar">
        <div className="header__top-bar-content">
          <Link to="/faqs" className="header__top-link">FAQs</Link>
          <span className="header__top-divider">|</span>
          <Link to="/contact" className="header__top-link">Contact Us</Link>
          <span className="header__top-divider">|</span>
          <Link to="/become-distributor" className="header__top-link">Become a Distributor</Link>
        </div>
      </div>
      <header className="header">
        <Link to="/" className="header__logo">
          <img src="https://i.postimg.cc/506WFbjs/Untitled-design-33.png" alt="Derma Protec Logo" />
        </Link>
        
        {/* Mobile Toggle Button */}
        <button
          className={`header__toggle${mobileOpen ? ' open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Desktop Navigation */}
        <nav className="header__nav desktop-nav">
          <ul className="header__menu">
            {menuItems.map(item => (
              <li
                key={item.name || item}
                className={`header__menu-item${item.dropdown ? ' has-dropdown' : ''}`}
                onMouseEnter={() => item.dropdown && handleDropdownToggle(item.name)}
                onMouseLeave={() => item.dropdown && handleDropdownToggle(null)}
              >
                {item.dropdown ? (
                  <>
                    <Link 
                      to={item.to || '#'} 
                      className="header__menu-link"
                    >
                      {item.name} <span className="dropdown-arrow">▼</span>
                    </Link>
                    <ul className={`dropdown-menu${activeDropdown === item.name ? ' open' : ''}`}>
                      {item.dropdown.map(sub => (
                        <li key={sub.name} className="dropdown-item">
                          <Link to={sub.to} className="dropdown-link">{sub.name}</Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={item.to} className="header__menu-link">{item.name}</Link>
                )}
              </li>
            ))}
          </ul>
          <div className="header__cta">
            <Link to="/find-dealer" className="find-dealer-btn">Find a Dealer</Link>
          </div>
        </nav>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav${mobileOpen ? ' open' : ''}`}>
          <ul className="mobile-menu">
            {menuItems.map(item => (
              <li key={item.name} className="mobile-menu-item">
                {item.dropdown ? (
                  <>
                    <div 
                      className="mobile-menu-link"
                      onClick={() => handleDropdownToggle(item.name)}
                    >
                      {item.name} <span className="mobile-arrow">▼</span>
                    </div>
                    <ul className={`mobile-dropdown${activeDropdown === item.name ? ' open' : ''}`}>
                      {item.dropdown.map(sub => (
                        <li key={sub.name} className="mobile-dropdown-item">
                          <Link 
                            to={sub.to} 
                            className="mobile-dropdown-link"
                            onClick={() => setMobileOpen(false)}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link 
                    to={item.to} 
                    className="mobile-menu-link"
                    onClick={() => setMobileOpen(false)}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          <div className="mobile-cta">
            <Link 
              to="/find-dealer" 
              className="mobile-find-dealer-btn"
              onClick={() => setMobileOpen(false)}
            >
              Find a Dealer
            </Link>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header; 